import { useEffect } from 'react';
import { graphManager } from './getGraphAccessToken';

/**
 * Callback page for the Graph OAuth flow (ADR 0019) — reached as the popup
 * window `signinPopup()` opens. (Never as a silent-renew iframe: the shell's
 * `frame-ancestors 'none'` / `X-Frame-Options: DENY` forbid framing it, so
 * getGraphAccessToken doesn't try.) `signinCallback()` is oidc-client-ts's
 * generic entry point — it inspects how the page was loaded and resolves
 * the right flow without this page needing to know which one it is.
 */
export default function GraphCallback() {
  useEffect(() => {
    graphManager()
      .signinCallback()
      .catch(() => {
        // Best-effort — the opener's pending signinPopup() promise
        // rejects on its own; nothing else for this page to do.
      });
  }, []);

  return <div>Connecting to your Microsoft account…</div>;
}
